import { FeaturesReady } from '@growthbook/growthbook-react';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import { GDLinkV1, GDLinkV1Variants } from 'dpl/common/core';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { useAdUrlParams } from 'dpl/hooks/useAdUrlParams';
import { BUYER_APP_STORE_URL } from 'dpl/shared/constants/urls';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import useStickyFilters from 'dpl/search_result_filters/hooks/useStickyFilters';

function ConsumerAppDownloadBannerContent({ analytics }) {
  const { hasMobileStickyFiltersEnabled } = useStickyFilters();

  const { isAdUrl } = useAdUrlParams();

  if (isAdUrl || hasMobileStickyFiltersEnabled) {
    return null;
  }

  const buttonCTA = 'Open';

  return (
    <div className="ConsumerAppDownloadBanner flex justify-between bg-blue-500 items-center ph6 white">
      <div className="flex items-center" style={{ gap: '0.7rem' }}>
        <Icon
          name="handsome-g"
          height="40"
          width="40"
          className="br3 bg-lightest-blue ph2 pv2 stone-700"
        />
        <div>
          <p className="f2">Good Dog</p>
          <p className="f1 lightest-purple o-80">Find the dog of your dreams</p>
        </div>
      </div>
      <GDLinkV1
        className="bg-lightest-purple"
        href={BUYER_APP_STORE_URL}
        outlined
        variant={GDLinkV1Variants.PRIMARY}
        onClick={() => {
          sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
            ...analytics,
            button_cta: buttonCTA,
            view_feature: ANALYTICS_VIEW_FEATURES.CONSUMER_APP_DOWNLOAD_BANNER
          });
        }}
      >
        {buttonCTA}
      </GDLinkV1>
    </div>
  );
}

ConsumerAppDownloadBannerContent.propTypes = {
  analytics: PropTypes.shape({
    view: PropTypes.string,
    view_feature_location: PropTypes.string
  })
};

ConsumerAppDownloadBannerContent.defaultProps = {
  analytics: null
};

export function ConsumerAppDownloadBanner(props) {
  return (
    <FeaturesReady timeout={500}>
      <ConsumerAppDownloadBannerContent {...props} />
    </FeaturesReady>
  );
}
